import { styled } from '@mui/material/styles';
export const Disclaimer = styled('div')(({ theme }) => ({
    padding: '20px 0',
    fontSize: 12,
    lineHeight: 1.67,
    color: theme.palette.black60.main,
    borderTop: `1px solid ${theme.palette.black40.main}`,
    '& p': {
        margin: 0,
    },
}));
//# sourceMappingURL=styles.js.map